"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchPreviewData = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
/* istanbul ignore file -- api file */

/**
 * Fetch function that fetches search preview data
 */
const getSearchPreviewData = async ({
  graphQlNetUrl,
  query,
  limit,
  headers
}) => {
  const data = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.searchPreviewQuery,
    url: graphQlNetUrl,
    variables: {
      query,
      limit
    },
    headers,
    timeout: 10000
  });
  return data;
};
exports.getSearchPreviewData = getSearchPreviewData;